module.exports = __webpack_public_path__ + "img/tu4.d7f05607.png";